﻿import { useMutation } from 'react-query';
import ImageProcessingApi from '../../api/ImageProcessingApi';

export function useDeleteRoomTag(orderId: number, imageId: number, onError: (error: unknown, currentRoomTag: string) => void) {
    let deleteRoomTagMutation = useMutation(({ roomTag }: { roomTag: number }) => {
        return ImageProcessingApi.deleteRoomTag(orderId, imageId, roomTag);
    }, {
        onError: (error: unknown, variables: any) => {
            onError(error, variables.roomTag);
        }
    });

    return async function deleteRoomTag(roomTag: number) {
        await deleteRoomTagMutation.mutate({ roomTag });
    };
}
